import '../translations'
import '../styles/tailwind-utilities.css'
import * as React from 'react'
import * as Sentry from '@sentry/react'
import { SENTRY_DSN } from '../Constants'
import { HelpCenter } from '../types'
import App from './containers/App'
import { Provider } from 'react-redux'
import store from './store'
import { ThemeProvider } from 'styled-components'

Sentry.init({
  dsn: SENTRY_DSN
})

interface IProps {
  help_center: HelpCenter
}

const ApplicationProvider = (props: IProps) => {
  const { help_center } = props

  return (
    <React.Suspense fallback={null}>
      <Provider store={store}>
        <ThemeProvider theme={{
          colors: {
            body: help_center.background_color,
            action: help_center.action_color,
            headerBackground: help_center.header_background_color,
            headerColor: help_center.header_text_color
          },
        }}>
          <App />
        </ThemeProvider>
      </Provider>
    </React.Suspense>
  )
}

export default ApplicationProvider